/**
 * Directive to choose language
 **/
import './services.location';
app.directive('slLanguageChooser', [
  '$rootScope',
  'locationService',
  function ($rootScope, locationService) {
    return {
      restrict: 'C',
      scope: {},
      link: function (scope, element) {
        const queryParams = locationService.getQueryParams();
        const { is_preview: isPreviewMapping } =
          locationService.queryParamsMapping;

        if (queryParams['is_preview'] === isPreviewMapping.v2PageBuilder) {
          return;
        }
        element.on('click', '.sl-language-chooser-language', function (event) {
          event.preventDefault();
          var language = $(event.currentTarget).attr('href').slice(1);
          $rootScope.changeLanguage(language);
        });
        element.on('$destroy', function () {
          element.off(); // Unbind events
        });
      },
    };
  },
]);
